import { render, staticRenderFns } from "./BookingTime.vue?vue&type=template&id=473b41fd&scoped=true&"
import script from "./BookingTime.vue?vue&type=script&lang=ts&"
export * from "./BookingTime.vue?vue&type=script&lang=ts&"
import style0 from "./BookingTime.vue?vue&type=style&index=0&id=473b41fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473b41fd",
  null
  
)

export default component.exports